import * as Sentry from '@sentry/react';
import { isMobile } from 'react-device-detect'
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoute from './common/components/PrivateRoute';
import PublicCompanyRoute from './common/components/PublicCompanyRoute';
import Layout from './common/Layout';
import { mobilePrivateCompanyRoutes, mobilePublicCompanyRoutes, mobilePublicRoutes, privateCompanyRoutes, publicCompanyRoutes, publicRoutes } from './routes';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari && isMobile) {
      let meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;

      if (!meta) {
        meta = document.createElement('meta');
        meta.name = "viewport";
        document.getElementsByTagName('head')[0].appendChild(meta);
      }

      meta.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0";
    }

    const loadingTcard = document.getElementById('loading-tcard')!;

    setTimeout(() => {
      loadingTcard?.classList?.add('loading-tcard_slide-top');

      setTimeout(() => {
        loadingTcard?.remove();
      }, 500);
    }, 1200);
  }, []);

  if (isMobile) {
    return (
      <div>
        <BrowserRouter>
          <SentryRoutes>
            {mobilePublicRoutes.map((route) => (
              <Route path={route.path} Component={route.comp} key={route.path} />
            ))}

            <Route element={<PublicCompanyRoute />}>
              {mobilePublicCompanyRoutes.map((route) => (
                <Route path={route.path} Component={route.comp} key={route.path} />
              ))}

              <Route element={<PrivateRoute />}>
                {mobilePrivateCompanyRoutes.map((route) => (
                  <Route path={route.path} Component={route.comp} key={route.path} />
                ))}
              </Route>
            </Route>
          </SentryRoutes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div>
      <BrowserRouter>
        <SentryRoutes>
          {publicRoutes.map((route) => (
            <Route path={route.path} Component={route.comp} key={route.path} />
          ))}

          <Route element={<PublicCompanyRoute />}>
            {publicCompanyRoutes.map((route) => (
              <Route path={route.path} Component={route.comp} key={route.path} />
            ))}

            <Route element={<Layout />}>
              <Route element={<PrivateRoute />}>
                {privateCompanyRoutes.map((route) => (
                  <Route path={route.path} Component={route.comp} key={route.path} />
                ))}
              </Route>
            </Route>
          </Route>
        </SentryRoutes>
      </BrowserRouter>
    </div>
  );
}

export default App;
